export const FETCH_DESTINATIONS_REQUEST = 'FETCH_DESTINATIONS_REQUEST';
export const FETCH_DESTINATIONS_SUCCESS = 'FETCH_DESTINATIONS_SUCCESS';
export const FETCH_DESTINATIONS_FAILED = 'FETCH_DESTINATIONS_FAILED';
export const SET_CURRENT_DESTINATION = 'SET_CURRENT_DESTINATION';

export const DELETE_DESTINATION_BY_ID_REQUEST = 'DELETE_DESTINATION_BY_ID_REQUEST';
export const DELETE_DESTINATION_BY_ID_SUCCESS = 'DELETE_DESTINATION_BY_ID_SUCCESS';
export const DELETE_DESTINATION_BY_ID_FAILED = 'DELETE_DESTINATION_BY_ID_FAILED';

export const CREATE_DESTINATION_REQUEST = 'CREATE_DESTINATION_REQUEST';
export const CREATE_DESTINATION_SUCCESS = 'CREATE_DESTINATION_SUCCESS';
export const CREATE_DESTINATION_FAILED = 'CREATE_DESTINATION_FAILED';

export const UPDATE_DESTINATION_REQUEST = 'UPDATE_DESTINATION_REQUEST';
export const UPDATE_DESTINATION_SUCCESS = 'UPDATE_DESTINATION_SUCCESS';
export const UPDATE_DESTINATION_FAILED = 'UPDATE_DESTINATION_FAILED';
